<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog" style="min-height:230px;">
		<div class="c-modal__content u-no-pt" *ngIf="!vm.loading">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<p class="c-text">{{ 'Employees.Kombo_Deactivate_Info' | translate }}</p>
				<br>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
						<button id="komboIntegrationDeactivateDeclineButton" class="c-button c-button--s6 c-button--fit c-button--narrow" (click)="vm.decline()">{{ 'Common.Cancel' | translate }}</button>
					</div>
					<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
						<button id="komboIntegrationDeactivateContinueButton" class="c-button c-button--s1 c-button--fit c-button--narrow" (click)="vm.confirm()">{{ 'Common.Continue' | translate }}</button>
					</div>
				</div>
		        <loader-overlay *ngIf="vm.loading"></loader-overlay>
	        </div>
		</div>
	</div>
</div>
